"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  precoolReducer: true
};
Object.defineProperty(exports, "precoolReducer", {
  enumerable: true,
  get: function get() {
    return _precool["default"];
  }
});

var _precool = _interopRequireDefault(require("./precool.reducer"));

var _precool2 = require("./precool.actions");

Object.keys(_precool2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _precool2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _precool2[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }